
define('modules/application/wizard/steps/zoneStep/zoneModel',[
  'app',
  // Libs
  'backbone',
  'jqueryUi',
  //Classes
  './zoneCollection'
], function(app, Backbone, jQueryUi, ZoneCollection) {

  var zoneModel = Backbone.Model.extend({
    defaults: {
      number      : -1,
      name        : '',
      description : '',
      valid       : false
    },

    initialize: function() {
      this.unbind('change:name', this.nameChangedEventHandler);
      this.bind('change:name', this.nameChangedEventHandler, this);
    },

    nameChangedEventHandler: function(e) {
      this.trigger('name:changed', e);
    },

    isRemovable: function() {
      return true;
    },

    isDuplicable: function() {
      return true;
    },

    isValid: function() {
      return this.get('valid');
    }
  });

  // Required, return the module for AMD compliance
  return zoneModel;

});